import type { FC } from 'react';

export type SvgIconName =
    | 'circle'
    | 'cross'
    | 'attention'
    | 'exit'
    | 'home'
    | 'closeCircle'
    | 'calendar'
    | 'leftChevron'
    | 'rightChevron';

export const SvgIcon: FC<{ name: SvgIconName; className?: string }> = ({ name, className }) => {
    return (
        <>
            {name === 'circle' && (
                <svg
                    className={className}
                    width="26"
                    height="26"
                    viewBox="0 0 26 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <circle cx="13" cy="13" r="11.5" stroke="#0070B9" strokeWidth="3" />
                </svg>
            )}
            {name === 'cross' && (
                <svg
                    className={className}
                    width="21"
                    height="21"
                    viewBox="0 0 21 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M20.7067 17.8787C21.0972 18.2692 21.0972 18.9024 20.7067 19.2929L19.2928 20.7068C18.9023 21.0973 18.2691 21.0973 17.8786 20.7068L0.2928 3.12102C-0.0977244 2.73049 -0.0977241 2.09733 0.2928 1.7068L1.70671 0.292892C2.09724 -0.0976318 2.7304 -0.0976318 3.12093 0.292892L20.7067 17.8787Z"
                        fill="#787878"
                    />
                    <path
                        d="M17.8786 0.292891C18.2691 -0.0976329 18.9023 -0.0976326 19.2928 0.292892L20.7067 1.7068C21.0972 2.09733 21.0972 2.73049 20.7067 3.12102L3.12092 20.7068C2.7304 21.0973 2.09724 21.0973 1.70671 20.7068L0.2928 19.2929C-0.0977241 18.9024 -0.0977242 18.2692 0.2928 17.8787L17.8786 0.292891Z"
                        fill="#787878"
                    />
                </svg>
            )}
            {name === 'attention' && (
                <svg
                    className={className}
                    width="20"
                    height="17"
                    viewBox="0 0 20 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M8.08267 0.849648C8.73708 -0.283205 10.3726 -0.283227 11.027 0.849648L18.8795 14.4502C19.5336 15.5835 18.7154 17 17.4069 17H1.70278C0.394198 17 -0.423976 15.5835 0.230128 14.4502L8.08267 0.849648ZM9.60025 12.6358C9.36344 12.6358 9.15352 12.7034 9.0065 12.8663C8.86288 13.026 8.80732 13.2481 8.80728 13.4981C8.80728 13.7451 8.86306 13.9642 9.00747 14.1221C9.15474 14.283 9.36401 14.3486 9.60025 14.3487C9.83403 14.3486 10.0418 14.2826 10.1872 14.1211C10.3291 13.9632 10.3844 13.7443 10.3844 13.4981C10.3844 13.2488 10.3293 13.0279 10.1881 12.8682C10.043 12.7043 9.83494 12.6358 9.60025 12.6358ZM9.60025 14.167L9.52603 14.1641C9.51373 14.1632 9.50176 14.1596 9.48989 14.1582C9.52488 14.1623 9.56159 14.167 9.60025 14.167ZM8.99673 13.6319C8.99487 13.6147 8.99197 13.5971 8.99087 13.5791L8.98892 13.4981C8.98892 13.5451 8.99218 13.5898 8.99673 13.6319ZM10.2028 13.4981L10.1999 13.5791C10.1991 13.5913 10.1961 13.6035 10.195 13.6153C10.1984 13.5781 10.2018 13.539 10.2018 13.4981C10.2018 13.4434 10.1989 13.3918 10.193 13.3438C10.1989 13.3919 10.2028 13.4434 10.2028 13.4981ZM9.67349 12.8204C9.68849 12.8215 9.70306 12.8253 9.71743 12.8272L9.60025 12.8184L9.67349 12.8204ZM9.60025 5.48441C9.37608 5.48445 9.1745 5.52305 9.027 5.62992C8.86705 5.74596 8.80071 5.92025 8.80728 6.11625L8.9938 11.3418V11.3438C9.00089 11.4899 9.05643 11.624 9.17739 11.7159C9.29106 11.8019 9.43778 11.8311 9.59048 11.8311C9.74684 11.8311 9.89696 11.8022 10.0124 11.7168C10.1361 11.6249 10.193 11.4891 10.1979 11.3409L10.1969 11.3399L10.3844 6.11137C10.391 5.91749 10.3249 5.74422 10.1667 5.62895C10.0207 5.52272 9.82127 5.48444 9.60025 5.48441Z"
                        fill="#FF2200"
                    />
                </svg>
            )}
            {name === 'exit' && (
                <svg
                    className={className}
                    width="18"
                    height="17"
                    viewBox="0 0 18 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M15.8327 7.77143C16.2242 7.77143 16.5416 8.09762 16.5416 8.5C16.5416 8.90238 16.2242 9.22857 15.8327 9.22857L7.32557 9.22857C6.93404 9.22857 6.61664 8.90238 6.61664 8.5C6.61664 8.09762 6.93404 7.77143 7.32557 7.77143L15.8327 7.77143Z"
                        fill="white"
                    />
                    <path
                        d="M11.3428 3.24916V1.7C11.3428 1.56587 11.237 1.45714 11.1065 1.45714H1.65416C1.52365 1.45714 1.41785 1.56587 1.41785 1.7V15.3C1.41785 15.4341 1.52365 15.5429 1.65416 15.5429H11.1065C11.237 15.5429 11.3428 15.4341 11.3428 15.3V14.1711C11.3428 13.7687 11.6602 13.4425 12.0517 13.4425C12.4433 13.4425 12.7607 13.7687 12.7607 14.1711V15.3C12.7607 16.2389 12.0201 17 11.1065 17H1.65416C0.740593 17 0 16.2389 0 15.3V1.7C0 0.761116 0.740593 0 1.65416 0H11.1065C12.0201 0 12.7607 0.761116 12.7607 1.7V3.24916C12.7606 3.65148 12.4432 3.97773 12.0517 3.97773C11.6603 3.97773 11.3429 3.65148 11.3428 3.24916Z"
                        fill="white"
                    />
                    <path
                        d="M17.8616 8.15655C18.0461 8.34623 18.0461 8.65377 17.8616 8.84345L15.2216 11.5566C14.9239 11.8625 14.4148 11.6458 14.4148 11.2131V5.7869C14.4148 5.35418 14.9239 5.13747 15.2216 5.44345L17.8616 8.15655Z"
                        fill="white"
                    />
                </svg>
            )}
            {name === 'home' && (
                <svg
                    className={className}
                    width="20"
                    height="18"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M2.75 10.6688C2.75 10.2128 2.95817 9.78172 3.31528 9.49995L10.5653 3.77627C11.4116 3.10823 12.5884 3.10823 13.4347 3.77627L20.6847 9.49995C21.0418 9.78172 21.25 10.2128 21.25 10.6688V19.5C21.25 20.7426 20.2426 21.75 19 21.75H15.25C14.8358 21.75 14.5 21.4142 14.5 21V16C14.5 15.5858 14.1642 15.25 13.75 15.25H10.25C9.83579 15.25 9.5 15.5858 9.5 16V21C9.5 21.4142 9.16421 21.75 8.75 21.75H5C3.75736 21.75 2.75 20.7426 2.75 19.5V10.6688Z"
                        fill="white"
                    />
                </svg>
            )}
            {name === 'closeCircle' && (
                <svg
                    className={className}
                    width="38"
                    height="38"
                    viewBox="0 0 38 38"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <circle cx="19" cy="19" r="19" fill="#333333" />
                    <path d="M10 10L28 28" stroke="white" strokeWidth="2" />
                    <path d="M10 28L28 10" stroke="white" strokeWidth="2" />
                </svg>
            )}
            {name === 'calendar' && (
                <svg
                    className={className}
                    width="23"
                    height="24"
                    viewBox="0 0 23 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M9.97778 9.16668H8.55555C8.18736 9.16668 7.88889 9.46515 7.88889 9.83334V11.3333C7.88889 11.7015 8.18736 12 8.55555 12H9.97778C10.346 12 10.6444 11.7015 10.6444 11.3333V9.83334C10.6444 9.46515 10.346 9.16668 9.97778 9.16668Z"
                        fill="#787878"
                    />
                    <path
                        d="M14.1111 9.16668H12.6889C12.3207 9.16668 12.0222 9.46515 12.0222 9.83334V11.3333C12.0222 11.7015 12.3207 12 12.6889 12H14.1111C14.4793 12 14.7778 11.7015 14.7778 11.3333V9.83334C14.7778 9.46515 14.4793 9.16668 14.1111 9.16668Z"
                        fill="#787878"
                    />
                    <path
                        d="M18.2444 9.16668H16.8222C16.454 9.16668 16.1556 9.46515 16.1556 9.83334V11.3333C16.1556 11.7015 16.454 12 16.8222 12H18.2444C18.6126 12 18.9111 11.7015 18.9111 11.3333V9.83334C18.9111 9.46515 18.6126 9.16668 18.2444 9.16668Z"
                        fill="#787878"
                    />
                    <path
                        d="M5.84444 13.4167H4.42222C4.05403 13.4167 3.75555 13.7152 3.75555 14.0833V15.5833C3.75555 15.9515 4.05403 16.25 4.42222 16.25H5.84444C6.21263 16.25 6.51111 15.9515 6.51111 15.5833V14.0833C6.51111 13.7152 6.21263 13.4167 5.84444 13.4167Z"
                        fill="#787878"
                    />
                    <path
                        d="M9.97778 13.4167H8.55555C8.18736 13.4167 7.88889 13.7152 7.88889 14.0833V15.5833C7.88889 15.9515 8.18736 16.25 8.55555 16.25H9.97778C10.346 16.25 10.6444 15.9515 10.6444 15.5833V14.0833C10.6444 13.7152 10.346 13.4167 9.97778 13.4167Z"
                        fill="#787878"
                    />
                    <path
                        d="M14.1111 13.4167H12.6889C12.3207 13.4167 12.0222 13.7152 12.0222 14.0833V15.5833C12.0222 15.9515 12.3207 16.25 12.6889 16.25H14.1111C14.4793 16.25 14.7778 15.9515 14.7778 15.5833V14.0833C14.7778 13.7152 14.4793 13.4167 14.1111 13.4167Z"
                        fill="#787878"
                    />
                    <path
                        d="M18.2444 13.4167H16.8222C16.454 13.4167 16.1556 13.7152 16.1556 14.0833V15.5833C16.1556 15.9515 16.454 16.25 16.8222 16.25H18.2444C18.6126 16.25 18.9111 15.9515 18.9111 15.5833V14.0833C18.9111 13.7152 18.6126 13.4167 18.2444 13.4167Z"
                        fill="#787878"
                    />
                    <path
                        d="M5.84444 17.6667H4.42222C4.05403 17.6667 3.75555 17.9652 3.75555 18.3333V19.8333C3.75555 20.2015 4.05403 20.5 4.42222 20.5H5.84444C6.21263 20.5 6.51111 20.2015 6.51111 19.8333V18.3333C6.51111 17.9652 6.21263 17.6667 5.84444 17.6667Z"
                        fill="#787878"
                    />
                    <path
                        d="M9.97778 17.6667H8.55555C8.18736 17.6667 7.88889 17.9652 7.88889 18.3333V19.8333C7.88889 20.2015 8.18736 20.5 8.55555 20.5H9.97778C10.346 20.5 10.6444 20.2015 10.6444 19.8333V18.3333C10.6444 17.9652 10.346 17.6667 9.97778 17.6667Z"
                        fill="#787878"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M4 4C4 5.28866 5.04467 6.33333 6.33333 6.33333C7.622 6.33333 8.66667 5.28866 8.66667 4V3H14V4C14 5.28866 15.0447 6.33333 16.3333 6.33333C17.622 6.33333 18.6667 5.28866 18.6667 4V3H20C21.4728 3 22.6667 4.19391 22.6667 5.66667V21C22.6667 22.4267 21.5463 23.5919 20.1374 23.6634L20 23.6667H2.66667L2.5293 23.6634C1.12037 23.5919 0 22.4267 0 21V5.66667C0 4.19391 1.19391 3 2.66667 3H4V4ZM2 21C2 21.3682 2.29848 21.6667 2.66667 21.6667H20C20.3682 21.6667 20.6667 21.3682 20.6667 21V7.66667H2V21Z"
                        fill="#787878"
                    />
                    <path
                        d="M5 4V1.33333C5 0.596954 5.59695 0 6.33333 0C7.06971 0 7.66667 0.596954 7.66667 1.33333V4C7.66667 4.73638 7.06971 5.33333 6.33333 5.33333C5.59695 5.33333 5 4.73638 5 4Z"
                        fill="#787878"
                    />
                    <path
                        d="M15 4V1.33333C15 0.596954 15.597 0 16.3333 0C17.0697 0 17.6667 0.596954 17.6667 1.33333V4C17.6667 4.73638 17.0697 5.33333 16.3333 5.33333C15.597 5.33333 15 4.73638 15 4Z"
                        fill="#787878"
                    />
                </svg>
            )}
            {name === 'leftChevron' && (
                <svg
                    className={className}
                    width="10"
                    height="18"
                    viewBox="0 0 10 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M0 8.66211C0 9.00391 0.126953 9.29688 0.400391 9.55078L7.99805 16.9922C8.21289 17.207 8.48633 17.3242 8.80859 17.3242C9.45312 17.3242 9.9707 16.8164 9.9707 16.1621C9.9707 15.8398 9.83398 15.5566 9.61914 15.332L2.77344 8.66211L9.61914 1.99219C9.83398 1.76758 9.9707 1.47461 9.9707 1.16211C9.9707 0.507812 9.45312 0 8.80859 0C8.48633 0 8.21289 0.117188 7.99805 0.332031L0.400391 7.76367C0.126953 8.02734 0 8.32031 0 8.66211Z"
                        fill="#0070B9"
                    />
                </svg>
            )}
            {name === 'rightChevron' && (
                <svg
                    className={className}
                    width="10"
                    height="18"
                    viewBox="0 0 10 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M9.9707 8.66211C9.96094 8.32031 9.83398 8.02734 9.57031 7.76367L1.97266 0.332031C1.74805 0.117188 1.48438 0 1.16211 0C0.507812 0 0 0.507812 0 1.16211C0 1.47461 0.126953 1.76758 0.351562 1.99219L7.1875 8.66211L0.351562 15.332C0.126953 15.5566 0 15.8398 0 16.1621C0 16.8164 0.507812 17.3242 1.16211 17.3242C1.47461 17.3242 1.74805 17.207 1.97266 16.9922L9.57031 9.55078C9.84375 9.29688 9.9707 9.00391 9.9707 8.66211Z"
                        fill="#0070B9"
                    />
                </svg>
            )}
        </>
    );
};
